import ContentLayout from "@/components/layout/ContentLayout"
import TermsServiceContent from "@/components/terms-service-content"
import { FC } from "react"

const TermsService: FC = () => {
  return (
    <ContentLayout title={"Terms of Service"}>
      <TermsServiceContent />
    </ContentLayout>
  )
}

export default TermsService 